import { Resume } from '@sr/types';
import Divider from '../common/Divider';
import { Box, ResumeHeading, Text, WebsiteLink } from '../common/ui';

const Header = ({ resume }: { resume: Resume }) => {
  const {
    city,
    email,
    firstName,
    lastName,
    phone,
    state,
    summary,
    title,
    website,
    website2,
  } = resume.about;
  return (
    <Box
      className="pdf-resume-header"
      variant="headerContainer"
      as="header"
      sx={{
        position: 'relative',
      }}
    >
      <ResumeHeading>
        {firstName} {lastName}
      </ResumeHeading>
      <Box
        sx={{
          display: ['block', 'flex'],
        }}
      >
        <Box variant="firstColumn" mb={[16, 0]}>
          {title && (
            <Text
              sx={{
                fontWeight: 'bold',
              }}
            >
              {title}
            </Text>
          )}
          {(city || state) && (
            <Text>
              <Divider divider=", ">
                {city}
                {state}
              </Divider>
            </Text>
          )}
          {website && (
            <Text>
              <WebsiteLink url={website} />
            </Text>
          )}
          {website2 && (
            <Text>
              <WebsiteLink url={website2} />
            </Text>
          )}
          {email && <Text>{email}</Text>}
          {phone && <Text>{phone}</Text>}
        </Box>
        <Text color="secondaryText">{summary}</Text>
      </Box>
    </Box>
  );
};

export default Header;
